import React, { useCallback, useMemo, useState } from "react";
import { DateRangePicker, DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Button } from "@mui/material";

import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { CustomButton } from "../../../../../components/Button/Button";

const WorkflowDateRangeFilter = ({ onClose }) => {
  const [Olddate, updateParams, removeSearchParam] =
    useCustomSearchParams("missingStatus");
  const date = JSON.parse(Olddate);
  const isMobile = useResponsive("down", "md");

  // Memoize the initial selection range
  const initialSelectionRange = useMemo(() => {
    return date
      ? [{
          startDate: new Date(date.startDate),
          endDate: new Date(date.endDate),
          key: "selection",
        }]
      : [{
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        }];
  }, [date]);

  const [selectionRange, setSelectionRange] = useState(initialSelectionRange);

  const handleSelect = useCallback((ranges) => {
    setSelectionRange([ranges.selection]);
  }, []);

  const setData = useCallback(() => {
    updateParams("missingStatus", JSON.stringify(selectionRange[0]));
    onClose();
  }, [selectionRange, updateParams, onClose]);

  return (
    <div className="d-grid">
      {isMobile ? (
        <DateRange
          ranges={selectionRange}
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          direction="horizontal"
        />
      ) : (
        <DateRangePicker
          ranges={selectionRange}
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          direction="horizontal"
        />
      )}
      {/* <DateRangePicker
      //  ranges={[selectionRange]}
       onChange={handleSelect}

          // ranges={selectionRange}
          // onChange={handleSelect}
          // showSelectionPreview={true}
          // moveRangeOnFirstSelection={false}
          // months={1}
          // direction="horizontal"
        /> */}
      <div className={`d-flex ${isMobile ? "mt-2" : ""}`}>
        <CustomButton
          onClick={() => {
            // setSelectionRange([0])
            onClose();
            removeSearchParam("missingStatus");
          }}
          className="reset-date-picker  reset-btn">
          Reset
        </CustomButton>
        <CustomButton
          onClick={setData}
          className="submit-date-picker"
          variant="contained">
          Submit
        </CustomButton>
      </div>
    </div>
  );
};

export default React.memo(WorkflowDateRangeFilter);
